/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSupportBulkUploadAvgFilesMutationRequest, AuditSupportBulkUploadAvgFilesMutationResponse, AuditSupportBulkUploadAvgFiles401, AuditSupportBulkUploadAvgFiles403 } from "../models/AuditSupportBulkUploadAvgFiles";
import { buildFormData } from "../.kubb/config";

export function getAuditSupportBulkUploadAvgFilesUrl() {
  const res = { method: 'POST', url: `/audit-support/v1/avg-files/bulk-upload` as const }
  return res
}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload AVG files
 * {@link /audit-support/v1/avg-files/bulk-upload}
 */
export async function auditSupportBulkUploadAvgFiles(data: AuditSupportBulkUploadAvgFilesMutationRequest, config: Partial<RequestConfig<AuditSupportBulkUploadAvgFilesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<AuditSupportBulkUploadAvgFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadAvgFiles401 | AuditSupportBulkUploadAvgFiles403>, AuditSupportBulkUploadAvgFilesMutationRequest>({ method : "POST", url : getAuditSupportBulkUploadAvgFilesUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}